angular.module("vgresiduos").factory("organizationService", [
	"$http",
	function ($http) {
		"use strict";

		const _getOrganization = function (id) {
			const req = {
				method: "get",
				url: Vgr.constants.coreHostUrl + "v1/organizations/" + id
			};
			return $http(req);
		};

		const _getOrganizationUnit = function (dto) {
			const req = {
				method: "get",
				url:
					Vgr.constants.coreHostUrl +
					"v1/organizations/" +
					dto.organizationId +
					"/organization-units/" +
					dto.organizationUnitCode
			};
			return $http(req);
		};

		// CORE
		const _isOrganizationOnlySSO = function (identityProvider) {
			const req = {
				method: "get",
				url: Vgr.constants.coreHostUrl + Vgr.resources.core.organization + "identity-provider/" + identityProvider
			};
			return $http(req);
		};

		return {
			getOrganization: _getOrganization,
			getOrganizationUnit: _getOrganizationUnit,
			isOrganizationOnlySSO: _isOrganizationOnlySSO
		};
	}
]);
